import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getEventLogs: async (options = {}) => {
    const {
      start,
      end,
      finds = {},
      orders = {},
      params = {},
    } = options;

    if (!start || !end) {
      throw new Error('start and end timestamps are required');
    }

    if (Number(end) <= Number(start)) {
      throw new Error('The "end" timestamp must be greater than "start" timestamp.');
    }

    const baseUrl = `/log/event/event/period/${start}/${end}`;

    const findsParts = [];
    Object.entries(finds).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      if (Array.isArray(value)) {
        value.forEach((v) => findsParts.push(`finds[${key}][]=${v}`));
      } else {
        findsParts.push(`finds[${key}]=${value}`);
      }
    });

    const ordersParts = [];
    Object.entries(orders).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      ordersParts.push(`orders[${key}]=${value}`);
    });

    const otherParts = [];
    Object.entries(params).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      otherParts.push(`${key}=${value}`);
    });

    const queryString = [...findsParts, ...ordersParts, ...otherParts].join('&');

    try {
      const response = await axiosInstance.get(`${baseUrl}?${queryString}`, {
        cancelToken: getNewCancelToken(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching log event:', error);
      throw error;
    }
  },
};
